<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <div
      id="page-container"
      class="enable-page-overlay side-scroll main-content-boxed"
    >
      <main id="main-container">
        <div class="content">
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label class="col-form-label">Selected Forms</label><br />
                <span class="badge bg-primary">form1 </span><br />
                <span class="badge bg-danger">form1 </span><br />
                <span class="badge bg-success">form1 </span>
              </div>
            </div>
            <div class="block block-bordered col-md-12" draggable="false">
              <!---->
              <div class="block-header block-header-default">
                <input
                  placeholder="productwidget/serviceswidget"
                  type="text"
                  class="border-0"
                />
                <h3 class="block-title"><!----></h3>
                <!---->
                <div class="block-options">
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-block-add-product"
                    class="btn-block-option"
                  >
                    <i class="fa fa-plus text-primary-dark"></i></button
                  ><button type="button" class="btn-block-option">
                    <i class="fa fa-clone text-primary-dark"></i></button
                  ><button
                    type="button"
                    data-toggle="block-option"
                    data-action="content_toggle"
                    class="btn-block-option"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div class="row">
                  <div class="col-md-3 mb-3">
                    <div class="mt-2 mb-2 text-secondary">
                      <label for="default1" class="font-size-sm"
                        ><input type="checkbox" id="default1" value="1" /> Set
                        Default
                      </label>
                    </div>
                    <div class="utility">
                      <div for="product-8">
                        <button
                          class="btn btn-warning float-right m-1"
                          data-bs-toggle="modal"
                          data-bs-target="#electricModal"
                          style="right: 0px; position: absolute"
                        >
                          <i class="far fa-edit"></i></button
                        ><img
                          src="https://crm.propropertypartners.com/images/request/v2/electra.png"
                        />
                        <span>form1 </span>
                        <br />
                        <span>Electricity</span
                        ><a class="more" style="z-index: 110">More info</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="mt-2 mb-2 text-secondary">
                      <label for="default3" class="font-size-sm"
                        ><input type="checkbox" id="default3" value="3" /> Set
                        Default
                      </label>
                    </div>
                    <div class="utility">
                      <div for="product-8">
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#waterModal"
                          class="btn btn-warning float-right m-1"
                          style="right: 0px; position: absolute"
                        >
                          <i class="far fa-edit"></i></button
                        ><img
                          src="https://crm.propropertypartners.com/images/request/v2/water.png"
                        />
                        <span>form1 </span>
                        <br />
                        <span>Water</span
                        ><a class="more" style="z-index: 110">More info</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="mt-2 mb-2 text-secondary">
                      <label for="default3" class="font-size-sm"
                        ><input type="checkbox" id="default3" value="3" /> Set
                        Default
                      </label>
                    </div>
                    <div class="utility">
                      <div for="product-8">
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#electricModal"
                          class="btn btn-warning float-right m-1"
                          style="right: 0px; position: absolute"
                        >
                          <i class="far fa-edit"></i></button
                        ><img
                          src="https://crm.propropertypartners.com/images/request/v2/tripple-play.png"
                        />
                        <span>form1 </span>
                        <br />
                        <span>İnternet / tv / telephony</span
                        ><a class="more" style="z-index: 110">More info</a>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
                <!---->
                <!---->
                <!---->
                <!---->
              </div>
            </div>
            <br />

            <div class="block block-bordered col-md-12">
              <!---->
              <div class="block-header block-header-default">
                <!---->
                <h3 class="block-title">Aan te sluiten adres</h3>
                <div class="block-options">
                  <button
                    type="button"
                    data-toggle="block-option"
                    data-action="content_toggle"
                    class="btn-block-option"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                </div>
                <!---->
              </div>
              <div class="block-content">
                <!---->
                <div>
                  <div>
                    <div class="row mt-2" id="addressBlock">
                      <div class="col-sm-4">
                        <label>Postcode </label>*<input
                          type="text"
                          class="mb-2 mr-sm-2 mb-sm-0 form-control"
                          required="required"
                          id="postcode"
                          name="widgets[address][zipcode]"
                        />
                      </div>
                      <div class="col-sm-4">
                        <label>Huisnummer </label>*<input
                          type="text"
                          class="mb-2 mr-sm-2 mb-sm-0 form-control"
                          required="required"
                          id="housenumber"
                          name="widgets[address][number]"
                        />
                      </div>
                      <div class="col-sm-4" style="display: inline-block">
                        <label id="numberaddition">Toevoeging</label>*
                        <div class="form-group">
                          <select
                            class="mb-2 mr-sm-2 mb-sm-0 form-control"
                            name="widgets[address][number_addition]"
                            id="number_addition"
                          ></select>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-2"
                      id="city-street-row"
                      style="display: flex"
                    >
                      <div class="col-md-6">
                        <label>Straat *</label
                        ><input
                          type="text"
                          class="form-control"
                          name="widgets[address][street]"
                          required="required"
                          id="street"
                        />
                      </div>
                      <div class="col-md-6">
                        <label>Plaats *</label
                        ><input
                          type="text"
                          class="form-control"
                          name="widgets[address][city]"
                          required="required"
                          id="city"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
                <!---->
                <!---->
                <!---->
              </div>
            </div>
            <!--electricty supplier-->
            <div class="block">
              <div class="block-header block-header-default">
                <h3 class="block-title">
                  <span>Electricity form1 </span>
                </h3>
                <div class="block-options">
                  <button
                    type="button"
                    data-toggle="block-option"
                    data-action="content_toggle"
                    class="btn-block-option"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                  <button type="button" class="btn-block-option">
                    <i class="si si-note"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-block-option"
                    data-bs-toggle="modal"
                    data-bs-target="#electricEditModal"
                  >
                    <i class="fas fa-user-edit"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div>
                  <div class="block block-bordered">
                    <!---->
                    <div class="block-header block-header-default">
                      <!---->
                      <h3 class="block-title">
                        <small> detailedoffer </small>
                      </h3>
                      <!---->
                      <!---->
                    </div>
                    <div class="block-content">
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                    </div>
                  </div>
                  <div class="block block-bordered">
                    <!---->
                    <div class="block-header block-header-default">
                      <!---->
                      <h3 class="block-title">
                        <small> choseduration </small>
                      </h3>
                      <!---->
                      <!---->
                    </div>
                    <div class="block-content">
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                    </div>
                  </div>

                  <div class="block block-bordered" draggable="false">
                    <!---->
                    <div class="block-header block-header-default">
                      <!---->
                      <h3 class="block-title">
                        <small> choosesupplier </small>
                      </h3>
                      <!---->
                      <div class="block-options">
                        <button
                          type="button"
                          data-toggle="modal"
                          data-target="#modal-block-add-supplier"
                          class="btn-block-option"
                        >
                          <i class="fa fa-plus text-primary-dark"></i></button
                        ><button
                          type="button"
                          data-toggle="block-option"
                          data-action="content_toggle"
                          class="btn-block-option"
                        >
                          <i class="si si-arrow-up"></i>
                        </button>
                      </div>
                    </div>
                    <div class="block-content">
                      <!---->
                      <!---->
                      <div class="row">
                        <table
                          class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                        >
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 70px"></th>
                              <th width="15%">Aanbieder</th>
                              <th class="d-sm-table-cell">Pakket</th>
                              <th
                                class="text-center d-sm-table-cell"
                                style="width: 20%"
                              >
                                Welkomstpremie
                              </th>
                              <th class="text-center d-sm-table-cell">
                                Per jaar
                              </th>
                              <th width="170px" class="d-sm-table-cell"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">
                                <div
                                  class="custom-control custom-radio custom-control-primary d-inline-block"
                                >
                                  <input
                                    type="radio"
                                    id="row60"
                                    name="rowsuppliers"
                                    class="custom-control-input"
                                  /><label
                                    for="row60"
                                    class="custom-control-label"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <img
                                  src="https://crm.propropertypartners.com/images/logo/eneco.jpg"
                                  class="img-fluid w-50"
                                />
                              </td>
                              <td class="d-sm-table-cell">
                                <span>(Form 1)</span><br />
                                <span
                                  >Consumenten EuropeseWind &amp; Gas 1
                                  jaar</span
                                >
                              </td>
                              <td class="text-center d-sm-table-cell">
                                <p class="font-w600 mb-1">€..</p>
                                <p class="text-muted mb-0">+...</p>
                              </td>
                              <td class="text-center d-sm-table-cell">€...</td>
                              <td>
                                <button
                                  class="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#supplierDeleteModal1"
                                >
                                  <span style="color: rgb(255, 255, 255)"
                                    ><i class="far fa-edit"></i
                                  ></span>
                                </button>
                                <div class="mt-2 mb-2 d-inline-block ml-2">
                                  <label
                                    for="electricity_default60"
                                    class="font-size-sm"
                                    ><input
                                      type="radio"
                                      id="electricity_default60"
                                      name="electricity_default"
                                      value="60"
                                    />
                                    Set Default
                                  </label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-center">
                                <div
                                  class="custom-control custom-radio custom-control-primary d-inline-block"
                                >
                                  <input
                                    type="radio"
                                    id="row53"
                                    name="rowsuppliers"
                                    class="custom-control-input"
                                  /><label
                                    for="row53"
                                    class="custom-control-label"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <img
                                  src="https://crm.propropertypartners.com/images/logo/energiedirectnl.jpg"
                                  class="img-fluid w-50"
                                />
                              </td>
                              <td class="d-sm-table-cell">
                                <span>(Form 1, Form 3)</span>
                                <br />
                                <span>DirectVoordeel 3 jaar</span>
                              </td>
                              <td class="text-center d-sm-table-cell">
                                <p class="font-w600 mb-1">€..</p>
                                <p class="text-muted mb-0">+...</p>
                              </td>
                              <td class="text-center d-sm-table-cell">€...</td>
                              <td>
                                <button
                                  class="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#supplierDeleteModal2"
                                >
                                  <span style="color: rgb(255, 255, 255)"
                                    ><i class="far fa-edit"></i
                                  ></span>
                                </button>
                                <div class="mt-2 mb-2 d-inline-block ml-2">
                                  <label
                                    for="electricity_default53"
                                    class="font-size-sm"
                                    ><input
                                      type="radio"
                                      id="electricity_default53"
                                      name="electricity_default"
                                      value="53"
                                    />
                                    Set Default
                                  </label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-center">
                                <div
                                  class="custom-control custom-radio custom-control-primary d-inline-block"
                                >
                                  <input
                                    type="radio"
                                    id="row52"
                                    name="rowsuppliers"
                                    class="custom-control-input"
                                  /><label
                                    for="row52"
                                    class="custom-control-label"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <img
                                  src="https://crm.propropertypartners.com/images/logo/energiedirectnl.jpg"
                                  class="img-fluid w-50"
                                />
                              </td>
                              <td class="d-sm-table-cell">
                                <span>(Form 1, Form 3)</span>
                                <br />
                                <span> DirectVoordeel 1 jaar </span>
                              </td>
                              <td class="text-center d-sm-table-cell">
                                <p class="font-w600 mb-1">€..</p>
                                <p class="text-muted mb-0">+...</p>
                              </td>
                              <td class="text-center d-sm-table-cell">€...</td>
                              <td>
                                <button
                                  class="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#supplierDeleteModal2"
                                >
                                  <span style="color: rgb(255, 255, 255)"
                                    ><i class="far fa-edit"></i
                                  ></span>
                                </button>
                                <div class="mt-2 mb-2 d-inline-block ml-2">
                                  <label
                                    for="electricity_default52"
                                    class="font-size-sm"
                                    ><input
                                      type="radio"
                                      id="electricity_default52"
                                      name="electricity_default"
                                      value="52"
                                    />
                                    Set Default
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!---->
                        <!---->
                      </div>
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                    </div>
                  </div>
                  <div class="block block-bordered">
                    <!---->
                    <div class="block-header block-header-default">
                      <!---->
                      <h3 class="block-title">
                        <small> customizeoffer </small>
                      </h3>
                      <!---->
                      <!---->
                    </div>
                    <div class="block-content">
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--electricty supplier-->
            <!--internet-->
            <div class="block">
              <div class="block-header block-header-default">
                <h3 class="block-title">
                  <span> İnternet / tv / telephony form1 </span>
                </h3>
                <div class="block-options">
                  <button
                    type="button"
                    data-toggle="block-option"
                    data-action="content_toggle"
                    class="btn-block-option"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                  <button type="button" class="btn-block-option">
                    <i class="si si-note"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-block-option"
                    data-bs-toggle="modal"
                    data-bs-target="#electricEditModal"
                  >
                    <i class="fas fa-user-edit"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div>
                  <div class="block block-bordered" draggable="false">
                    <!---->
                    <div class="block-header block-header-default">
                      <!---->
                      <h3 class="block-title">
                        <small> choosesupplier </small>
                      </h3>
                      <!---->
                      <div class="block-options">
                        <button
                          type="button"
                          data-toggle="modal"
                          data-target="#modal-block-add-supplier"
                          class="btn-block-option"
                        >
                          <i class="fa fa-plus text-primary-dark"></i></button
                        ><button
                          type="button"
                          data-toggle="block-option"
                          data-action="content_toggle"
                          class="btn-block-option"
                        >
                          <i class="si si-arrow-up"></i>
                        </button>
                      </div>
                    </div>
                    <div class="block-content">
                      <!---->
                      <ul
                        class="nav nav-pills mb-3"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link active"
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            type="button"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                          >
                            Internet
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="pills-profile"
                            aria-selected="false"
                          >
                            TV
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="pills-contact-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-contact"
                            type="button"
                            role="tab"
                            aria-controls="pills-contact"
                            aria-selected="false"
                          >
                            Call
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="pills-pick-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-pick"
                            type="button"
                            role="tab"
                            aria-controls="pills-pick"
                            aria-selected="false"
                          >
                            Pick a promotion
                          </button>
                        </li>
                      </ul>
                      <div class="tab-content" id="pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div class="row">
                            <table
                              class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                            >
                              <thead>
                                <tr>
                                  <th
                                    class="text-center"
                                    style="width: 70px"
                                  ></th>
                                  <th width="15%"></th>
                                  <th class="d-sm-table-cell"></th>
                                  <th
                                    class="text-center d-sm-table-cell"
                                    style="width: 20%"
                                  ></th>
                                  <th class="text-center d-sm-table-cell"></th>
                                  <th
                                    width="170px"
                                    class="d-sm-table-cell"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row60"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row60"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span><br />
                                    <span> Internet Complete 250Mbit </span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal1"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row53"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row53"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>(Form 1, Form 3)</span>
                                    <br />
                                    <span>Internet Max 500Mbit</span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal2"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row52"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row52"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span>
                                    <br />
                                    <span> Internet Giga 1000Mbit </span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal2"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                    <div
                                      class="mt-2 mb-2 d-inline-block ml-2"
                                    ></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!---->
                            <!---->
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                        >
                          Profile
                          <div class="row">
                            <table
                              class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                            >
                              <thead>
                                <tr>
                                  <th
                                    class="text-center"
                                    style="width: 70px"
                                  ></th>
                                  <th width="15%"></th>
                                  <th class="d-sm-table-cell"></th>
                                  <th
                                    class="text-center d-sm-table-cell"
                                    style="width: 20%"
                                  ></th>
                                  <th class="text-center d-sm-table-cell"></th>
                                  <th
                                    width="170px"
                                    class="d-sm-table-cell"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row60"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row60"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span><br />
                                    <span> TV Start </span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal1"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row53"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row53"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span>
                                    <br />
                                    <span>TV Complete</span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal2"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!---->
                            <!---->
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="pills-contact"
                          role="tabpanel"
                          aria-labelledby="pills-contact-tab"
                        >
                          Call
                          <div class="row">
                            <table
                              class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                            >
                              <thead>
                                <tr>
                                  <th
                                    class="text-center"
                                    style="width: 70px"
                                  ></th>
                                  <th width="15%"></th>
                                  <th class="d-sm-table-cell"></th>
                                  <th
                                    class="text-center d-sm-table-cell"
                                    style="width: 20%"
                                  ></th>
                                  <th class="text-center d-sm-table-cell"></th>
                                  <th
                                    width="170px"
                                    class="d-sm-table-cell"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row60"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row60"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span><br />
                                    <span> Yes, fixed calling </span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal1"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row53"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row53"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span>
                                    <br />
                                    <span>No fixed calling</span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal2"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!---->
                            <!---->
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="pills-pick"
                          role="tabpanel"
                          aria-labelledby="pills-pick-tab"
                        >
                          Pick
                          <div class="row">
                            <table
                              class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                            >
                              <thead>
                                <tr>
                                  <th
                                    class="text-center"
                                    style="width: 70px"
                                  ></th>
                                  <th width="15%"></th>
                                  <th class="d-sm-table-cell"></th>
                                  <th
                                    class="text-center d-sm-table-cell"
                                    style="width: 20%"
                                  ></th>
                                  <th class="text-center d-sm-table-cell"></th>
                                  <th
                                    width="170px"
                                    class="d-sm-table-cell"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row60"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row60"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span><br />
                                    <span> 3 free Wifi Boosters </span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal1"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center">
                                    <div
                                      class="custom-control custom-radio custom-control-primary d-inline-block"
                                    >
                                      <input
                                        type="radio"
                                        id="row53"
                                        name="rowsuppliers"
                                        class="custom-control-input"
                                      /><label
                                        for="row53"
                                        class="custom-control-label"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src="https://crm.propropertypartners.com/images/request/brand1.png"
                                      class="img-fluid w-50"
                                    />
                                  </td>
                                  <td class="d-sm-table-cell">
                                    <span>form1 </span>
                                    <br />
                                    <span>6 months 39,95 p/m</span>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    <p class="font-w600 mb-1">€..</p>
                                    <p class="text-muted mb-0">+...</p>
                                  </td>
                                  <td class="text-center d-sm-table-cell">
                                    €...
                                  </td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#supplierDeleteModal2"
                                    >
                                      <span style="color: rgb(255, 255, 255)"
                                        ><i class="far fa-edit"></i
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--internet-->
            <!--pilss-->
            <!-- <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Home</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Profile</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Contact</button>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">Home</div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">Profile</div>
            <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">Contact</div>
          </div> -->
            <!---pills end-->
            <!-- asdasdasdasdsda -->

            <div class="block widget">
              <div>
                <div class="block-header block-header-default">
                  <h3 class="block-title">
                    Family Situation
                    <span>form1 </span>
                  </h3>
                </div>
              </div>
              <div class="block-content">
                <div>
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <label class="font-w400"
                          >What is the family situation?</label
                        >
                        <div class="situation">
                          <div class="familyItems">
                            <div class="utility">
                              <input
                                id="consumption1"
                                name="consumption[family_situation]"
                                type="radio"
                                value="1"
                              /><label for="consumption1" class="familyLabel"
                                ><img
                                  width="12"
                                  src="https://crm.propropertypartners.com/images/request/v2/person1.png"
                                  class="familyImage"
                                  style="max-height: 80px"
                                /><span> 1 Person </span></label
                              >
                            </div>
                          </div>
                          <div class="familyItems">
                            <div class="utility">
                              <input
                                id="consumption2"
                                name="consumption[family_situation]"
                                type="radio"
                                value="2"
                              /><label for="consumption2" class="familyLabel"
                                ><img
                                  width="15"
                                  src="https://crm.propropertypartners.com/images/request/v2/person2.png"
                                  class="familyImage"
                                  style="max-height: 80px"
                                /><span> 2 People </span></label
                              >
                            </div>
                          </div>
                          <div class="familyItems">
                            <div class="utility">
                              <input
                                id="consumption3"
                                name="consumption[family_situation]"
                                type="radio"
                                value="3"
                              /><label for="consumption3" class="familyLabel"
                                ><img
                                  width="30"
                                  src="https://crm.propropertypartners.com/images/request/v2/person3.png"
                                  class="familyImage"
                                  style="max-height: 80px"
                                /><span> 3 People </span></label
                              >
                            </div>
                          </div>
                          <div class="familyItems">
                            <div class="utility">
                              <input
                                id="consumption4"
                                name="consumption[family_situation]"
                                type="radio"
                                value="4"
                              /><label for="consumption4" class="familyLabel"
                                ><img
                                  width="33"
                                  src="https://crm.propropertypartners.com/images/request/v2/person4.png"
                                  class="familyImage"
                                  style="max-height: 80px"
                                /><span> 4 People </span></label
                              >
                            </div>
                          </div>
                          <div class="familyItems">
                            <div class="utility">
                              <input
                                id="consumption5"
                                name="consumption[family_situation]"
                                type="radio"
                                value="5"
                              /><label for="consumption5" class="familyLabel"
                                ><img
                                  width="40"
                                  src="https://crm.propropertypartners.com/images/request/v2/person5.png"
                                  class="familyImage"
                                  style="max-height: 80px"
                                /><span> 5 People (+) </span></label
                              >
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
                <!----><!---->
              </div>
            </div>

            <!-- Mortgage start -->
            <div class="block block-bordered col-md-12 block-mode-hidden">
              <div class="block-header block-header-default">
                <h3 class="block-title">Mortgage Advice</h3>
                <div class="block-options">
                  <button
                    type="button"
                    class="btn-block-option"
                    data-toggle="block-option"
                    data-action="content_toggle"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div class="row">
                  <div class="col-md-4">
                    <label id="mortgage-first"
                      >Je bruto jaarinkomen/winst*</label
                    >
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >€</span
                        >
                      </div>
                      <input
                        id="firstIncome"
                        type="number"
                        class="form-control"
                        required=""
                        name="widgets[firstIncome]"
                        onkeydown="javascript: return event.keyCode === 8 ||
                                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                      />
                    </div>

                    <br />
                    <label id="mortgage-second"
                      >Bruto jaarinkomen/winst van je partner</label
                    >
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >€</span
                        >
                      </div>
                      <input
                        id="secondIncome"
                        type="number"
                        class="form-control"
                        name="widgets[secondIncome]"
                        onkeydown="javascript: return event.keyCode === 8 ||
                                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                      />
                    </div>
                  </div>
                  <div class="col-md-8">
                    <br />
                    <div class="box col-md-8">
                      <label style="background-color: white" class="row">
                        <div class="col-md-8" style="text-align: left">
                          <h3 style="color: black">
                            <label id="max-mortgage">€ 0</label>
                          </h3>
                          <h5 style="color: black" id="mortgage-br">
                            <label id="brutomortgage">Bruto maandslaten</label>
                            € <label id="brut-mortgage">0</label>
                          </h5>
                          <p style="color: black" id="rente-mortgage">
                            <label id="mortgage-rente">Rente</label
                            ><label id="mortgage-rate"></label
                            ><label id="mortgage-year"></label>
                            <label id="mortgage-rateType"></label>
                          </p>
                        </div>
                        <div
                          class="col-md-4 mortgage-image"
                          style="text-align: center"
                        >
                          <img
                            src="widget-editor/img/mortgage-guy.svg"
                            style="max-width: -webkit-fill-available"
                          />
                        </div>
                        <div class="mortgage-modal" id="mortgage-advice-modal">
                          <a data-toggle="modal" data-target="#moreinfo">
                            <label id="mortgage-more-info"
                              >Read the conditions of the calculation
                              here</label
                            ></a
                          >
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Mortgage end -->
            <!--Persoonsgegevens Start-->
            <div class="block block-bordered col-md-12 block-mode-hidden">
              <div class="block-header block-header-default">
                <h3 class="block-title">Persoonsgegevens Van de Klant</h3>
                <div class="block-options">
                  <button
                    type="button"
                    class="btn-block-option"
                    data-toggle="block-option"
                    data-action="content_toggle"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div class="col-md-12"></div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block" id="aanhef" for="">Aanhef *</label>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="m"
                        checked="checked"
                        id="genderm"
                        name="widgets[personaldata][gender]"
                      />
                      <label id="genderm" class="form-check-label" for="genderm"
                        >De heer</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="v"
                        id="genderv"
                        name="widgets[personaldata][gender]"
                      />
                      <label id="genderv" class="form-check-label" for="genderv"
                        >Mevrouw</label
                      >
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label id="bedrijfsnaam1">Bedrijfsnaam </label>
                    <input
                      type="text"
                      class="form-control"
                      id="bedrijfsnaam"
                      name="widgets[personaldata][bedrijfsnaam]"
                      value=""
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label id="kvk1">KVK</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kvk"
                      name="widgets[personaldata][kvk]"
                    />
                  </div>

                  <div class="col-md-4 col-sm-12">
                    <label>Voorletters </label> *
                    <input
                      type="text"
                      class="form-control"
                      id="initials"
                      name="widgets[personaldata][initials]"
                      required="required"
                      value=""
                    />
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <label>Voornaam</label> *
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      required="required"
                      name="widgets[personaldata][firstname]"
                    />
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <label>Achternaam </label>*
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      required="required"
                      name="widgets[personaldata][lastname]"
                    />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-4 col-sm-12">
                    <label>Geboortedatum </label>*
                    <input
                      type="text"
                      class="form-control dateinput"
                      id="date_of_birth"
                      required="required"
                      name="widgets[personaldata][date_of_birth]"
                    />
                  </div>
                  <div class="col-md-8 col-sm-12">
                    <label id="emailaddress">E-mailadres </label>*
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      required="required"
                      name="widgets[personaldata][email]"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label id="phone">Telefoonnummer overdag </label>*
                    <input
                      type="text"
                      class="form-control"
                      required="required"
                      id="phone-6"
                      name="widgets[personaldata][phone]"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label>Telefoonnummer 's avonds</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone2"
                      name="widgets[personaldata][phone2]"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label>IBAN </label>*
                    <input
                      type="text"
                      class="form-control"
                      id="iban"
                      required="required"
                      name="widgets[personaldata][iban]"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label id="nation">Nationaliteit *</label>

                    <div class="form-group">
                      <select
                        class="form-control"
                        required="required"
                        name="widgets[personaldata][nationality]"
                        id="nationality"
                      ></select>
                    </div>


                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group"></div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="d-block" id="taalklant">Taal klant *</label>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="1"
                          id="language_id"
                          name="widgets[personaldata][language_id]"
                          required="required"
                        />
                        <label
                          class="form-check-label"
                          for="language_id"
                          id="taalklantop1"
                          >Nederlands</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="2"
                          id="language_id2"
                          name="widgets[personaldata][language_id]"
                        />
                        <label
                          class="form-check-label"
                          for="language_id2"
                          id="taalklantop2"
                          >Engels</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="d-block" id="betaalwijze"
                        >Betaalwijze *</label
                      >
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="ai"
                          checked=""
                          id="betaalwijze_ai"
                          name="widgets[personaldata][betaalwijze]"
                        />
                        <label
                          class="form-check-label"
                          for="betaalwijze_ai"
                          id="betaalwijzeop1"
                          >Automatische incasso</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="ag"
                          id="betaalwijze_ag"
                          name="widgets[personaldata][betaalwijze]"
                        />
                        <label
                          class="form-check-label"
                          for="betaalwijze_ag"
                          id="betaalwijzeop2"
                          >Acceptgiro</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="form-group"></div>
                  </div>
                </div>
              </div>
            </div>
            <!--Persoonsgegevens End-->
            <!--Adress start-->
            <div class="block block-bordered col-md-12 block-mode-hidden">
              <div class="block-header block-header-default">
                <h3 class="block-title">Aan te sluiten adres</h3>
                <div class="block-options">
                  <button
                    type="button"
                    class="btn-block-option"
                    data-toggle="block-option"
                    data-action="content_toggle"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <div class="row">
                  <div class="col-sm-4">
                    <label>Postcode *</label>
                    <input
                      type="text"
                      class="mb-2 mr-sm-2 mb-sm-0 form-control"
                      required="required"
                      id="postcode"
                      name="widgets[address][zipcode]"
                    />
                  </div>
                  <div class="col-sm-4">
                    <label>Huisnummer *</label>
                    <input
                      type="text"
                      class="mb-2 mr-sm-2 mb-sm-0 form-control"
                      required="required"
                      id="housenumber"
                      name="widgets[address][number]"
                    />
                  </div>
                  <div class="col-sm-4">
                    <label id="numberaddition">Toevoeging *</label>*
                    <div class="form-group">
                      <select
                        class="form-control"
                        name="widgets[address][number_addition]"
                        id="number_addition"
                      ></select>
                    </div>
                  </div>
                  <div class="col-6">
                    <label>Straat *</label>
                    <input
                      type="text"
                      class="mb-2 mr-sm-2 mb-sm-0 form-control"
                      name="widgets[address][street]"
                      required="required"
                      id="street"
                    />
                  </div>
                  <div class="col-6">
                    <label>Plaats *</label>
                    <input
                      type="text"
                      class="mb-2 mr-sm-2 mb-sm-0 form-control"
                      name="widgets[address][city]"
                      required="required"
                      id="city"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!--Adress end-->
          </div>
          <div class="row">
            <div class="col-3">
              <button
                class="btn btn-outline-warning btn-lg btn-block"
                @click="$router.push('/')"
              >
                Dashboard
              </button>
            </div>
            <div class="col-3">
              <button class="btn btn-outline-info btn-lg btn-block">
                Save as Draft
              </button>
            </div>
            <div class="col-3">
              <button class="btn btn-outline-success btn-lg btn-block">
                Publish
              </button>
            </div>
            <div class="col-3">
              <button
                class="btn btn-warning btn-lg btn-block"
                type="button"
                data-toggle="modal"
                data-target="#modal-block-custom-css"
              >
                Add Custom Css
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </main>
    </div>
    <!-- Modals -->

    <div
      class="modal fade"
      id="supplierDeleteModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Which one to delete?
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <input type="checkbox" /> form1
            <br />
            <input type="checkbox" /> form1
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="electricModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Electricity?
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md 6">
                <h4>Delete from forms</h4>
                <input type="checkbox" /> form1
                <br />
                <input type="checkbox" /> form1
              </div>
              <div class="col-md 6">
                <h4>Add to forms</h4>
                <input type="checkbox" /> form1
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="waterModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Water</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md 6">
                <h4>Delete from forms</h4>
                <input type="checkbox" /> form1
                <br />
                <input type="checkbox" /> form1
                <br />
                <input type="checkbox" /> form1
              </div>
              <div class="col-md 6">
                <h4>Add to forms</h4>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="electricEditModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Which one to add?
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body"><input type="checkbox" /> form1</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-block-add-supplier"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Which one to add?
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body"><input type="checkbox" />form1</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-block-add-product"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add products?</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body"><input type="checkbox" /> form1</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="supplierDeleteModal2"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Suppliers</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md 6">
                <h4>Delete from forms</h4>
                <input type="checkbox" /> form1
                <br />
                <input type="checkbox" /> form1
              </div>
              <div class="col-md 6">
                <h4>Add to forms</h4>
                <input type="checkbox" /> Form 2
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="supplierDeleteModal1"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Suppliers</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md 6">
                <h4>Delete from forms</h4>
                <input type="checkbox" /> form1
              </div>
              <div class="col-md 6">
                <h4>Add to forms</h4>
                <input type="checkbox" /> form1
                <br />
                <input type="checkbox" /> form1
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <input type=hidden name="extra[redirect]" id="redirect">
  </div>
</template>
<script>
import HeaderComponent from "../../components/layout/Header";
import SidebarComponent from "../../components/layout/Sidebar";
import safeLocalStorage from "../../utils/localstorage";
export default {
  name: "formManager",
  components: {
    SidebarComponent,
    HeaderComponent
  },
  data: () => {
    return {
      selectedForms: [],
      type: ""
    };
  },
  mounted() {
    this.selectedForms = JSON.parse(safeLocalStorage.getItem("selectedForms"));
  }
};
</script>
<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}

@media only screen and (max-width: 600px) {
  .situation {
  }
  .familyImage {
    display: none;
  }
  .familyLabel {
    height: 50px;
  }
  .familySpan {
  }
}

@media only screen and (min-width: 601px) {
  .situation {
    display: flex;
    justify-content: space-between;
  }
  .familyItems {
    flex: 0.18;
  }
  .familyLabel {
    height: 130px;
  }
  .familySpan {
    display: flex;
    align-self: center;
    flex-direction: column;
    margin-top: 40%;
  }
}

td,
th {
  border-width: 1px;
}
</style>
